@for (alert of alerts; track alert) {
  <div class="{{cssClass(alert)}}" style="margin-top: 4%;">
    <!-- <a class="close" (click)="removeAlert(alert)">&times;</a> -->
    <span [innerHTML]="alert.message"></span>
  </div>
}